const counterId = process.env.REACT_APP_YANDEX_METRIKA_ID || "110868709";

export const initMetrika = () => {
  if (!counterId || typeof document === "undefined") return;

  if (!window.__pirogiMetrikaPhoneListener) {
    window.__pirogiMetrikaPhoneListener = true;
    document.addEventListener("click", (event) => {
      const link = event.target.closest?.('a[href^="tel:"]');
      if (link) reachGoal("phone_click");
    });
  }
};

export const reachGoal = (target, params) => {
  if (!counterId || typeof window === "undefined" || typeof window.ym !== "function") {
    return;
  }

  window.ym(counterId, "reachGoal", target, params);
};

export const hit = (url = window.location.href) => {
  if (!counterId || typeof window === "undefined" || typeof window.ym !== "function") {
    return;
  }

  window.ym(counterId, "hit", url, { title: document.title });
};
